import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentPageHeader } from '../../molecules/page-header/ContentPageHeader';
import { TRY_THEN_BUY_FRAUD } from '../../../constants/define/translation';

export const TTBFraudPageHeader = () => {
  const { t } = useTranslation(TRY_THEN_BUY_FRAUD);

  return <ContentPageHeader title={t('header.title')} />;
};
